import * as paymentoptions from 'smg/customer-api/paymentoptions';

import * as carts from '../../carts';
import { State } from '../state';

// ResolveMerchantToken returns the Stax web-payments token every BlockChyp
// mount on this checkout must be built under. BlockChyp's tokenizing key is
// per-merchant (#8111), so the mount has to know its merchant BEFORE the
// customer types a digit.
//
// Before the order exists, this resolves by the cart — matching whatever
// brand /orders will create the order under. Once state.orderResp is set
// (the order exists), it resolves by the order's own id instead: the order's
// realm can differ from the cart's via normalizeNewOrderRealmToSalesTeam
// (#7537), so a mount built or rebuilt after order creation must ask by
// orderID, not cart, or it would keep minting tokens under a merchant the
// order can never exchange them with.
//
// Cached on state.merchantToken so every mount this checkout builds AND the
// #7537 parity check in PersistPendingPaymentOption share one resolution.
// Cleared on rejection (empty token, tokenizing-key lookup failure, iframe
// load failure) so a later mount/retry re-resolves instead of reusing a dead
// promise — same shape as Depot's resolveMerchantToken in
// depot/ts/pages/checkout.ts.
export function ResolveMerchantToken(state: State): Promise<string> {
    if (!state.merchantToken) {
        const lookup = state.orderResp?.orderID ?
            paymentoptions.PaymentMerchant({ orderIDs: [state.orderResp.orderID] }) :
            paymentoptions.PaymentMerchant({ cartID: carts.GetCartID() ?? '' });
        const pending: Promise<string> = lookup.then(merchant => {
            if (!merchant.webPaymentsToken) {
                throw new Error('This brand is missing its payment processor configuration, so the card cannot be entered. Please contact us to complete your order.');
            }
            return merchant.webPaymentsToken;
        });
        state.merchantToken = pending;
        pending.catch(() => {
            // Clear the cache only if it still holds THIS promise — Start
            // Over (or the parity remount) may already have replaced it
            // with a newer lookup, and a stale rejection clearing that one
            // would drop live token provenance and force a needless
            // re-enter-your-card cycle.
            if (state.merchantToken === pending) {
                state.merchantToken = undefined;
            }
        });
    }
    return state.merchantToken;
}
